import { pathEq } from 'ramda'

const targetIsCheckbox = pathEq(['target', 'type'], 'checkbox')

export default targetIsCheckbox